import useSWR from 'swr';
import { useLendingSupportService } from 'hooks/services';
import { getKey, Resource } from './key';

export const useCrmMergeLeadsOperations = (dealId?: string) => {
  const { getDealCrmMergeLeadsOperations } = useLendingSupportService();

  const { data, error, isLoading } = useSWR(
    dealId ? getKey(Resource.CRM_MERGE_LEADS_OPERATIONS, { dealId }) : null,
    (key) => getDealCrmMergeLeadsOperations(key.params),
    { revalidateOnFocus: false },
  );

  return {
    operations: data,
    error,
    isLoading,
  };
};
